import { get } from 'api/client';
import { PageUserWithMobileApp } from 'types/User';

export function getUsersWithMobileApp(
  pageId: number,
): Promise<PageUserWithMobileApp[]> {
  return get(`pages/ajaxGetUsersWithMobileApp`, {
    params: { id: pageId },
  });
}
